/**
 * Signup form component for FreeAccount page
 * @author Housefolios
 * @modifiedBy David Helmick
 * @modifiedTime 2025-06-17 14:05:00
 */

import React from 'react'
import {
  Grid,
  Typography,
  FormControlLabel,
  Checkbox,
  Link,
  Button,
  TextField,
  Box,
} from '@mui/material'
import { Link as RouterLink } from 'react-router'
import FormSection from '../Shared/FormSection'
import { ValidatorForm } from '@/housefolios-components/shared/utils/formValidator'
import {
  pageShellMainSx,
  pageShellContentSx,
  pageShellInnerSx,
} from '@/layout-blueprints/chromeSx'

const SignupForm = ({
  email,
  setEmail,
  password,
  setPassword,
  passwordMask,
  setPasswordMask,
  firstName,
  setFirstName,
  lastName,
  setLastName,
  phoneNumber,
  setPhoneNumber,
  agree,
  setAgree,
  signUpError,
  handleSubmit,
}) => {
  return (
    <Box sx={pageShellMainSx}>
      <Box sx={pageShellContentSx}>
        <Box sx={pageShellInnerSx}>
          <Box
            sx={{
              flexGrow: 1,
              width: '100%',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Box sx={[{ py: '3rem' }, { position: "relative", zIndex: "7", width: "100%" }]}>
              <ValidatorForm onSubmit={handleSubmit}>
                <Grid
                  container
                  spacing={0}
                  sx={{
                    justifyContent: 'space-around',
                  }}
                >
                  <Grid
                    sx={{ display: 'flex', alignItems: 'center' }}
                  >
                    <Grid sx={{ mx: 'auto' }}>
                      <Grid
                        container
                        direction="column"
                        sx={{
                          justifyContent: 'space-evenly',
                        }}
                      >
                        <Grid>
                          <Box
                            sx={{ textAlign: 'center', mb: '3rem' }}
                          >
                            <Box component="h1" sx={[{ mb: '0.25rem', fontWeight: 700 }, { fontSize: "1.7rem", fontWeight: "300", lineHeight: "1.2" }]}>
                              SIGN UP FOR YOUR FREE ACCOUNT
                            </Box>
                          </Box>
                        </Grid>
                        <FormSection
                          email={email}
                          setEmail={setEmail}
                          password={password}
                          setPassword={setPassword}
                          passwordMask={passwordMask}
                          setPasswordMask={setPasswordMask}
                          firstName={firstName}
                          setFirstName={setFirstName}
                          lastName={lastName}
                          setLastName={setLastName}
                          phoneNumber={phoneNumber}
                          setPhoneNumber={setPhoneNumber}
                          signUpError={signUpError}
                        />
                        <Grid
                          size={12}
                          container
                          direction="row"
                          style={{
                            paddingLeft: 50,
                            paddingRight: 50,
                          }}
                          sx={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <Grid>
                            <FormControlLabel
                              control={
                                <Checkbox
                                  checked={agree}
                                  required
                                  onChange={() => setAgree(!agree)}
                                />
                              }
                              label={
                                <Typography>
                                  I have read and agree to the{' '}
                                  <Link
                                    component={RouterLink}
                                    to="/Terms"
                                    underline="hover"
                                    style={{
                                      color: '#04a3e3',
                                    }}
                                    target="_blank"
                                  >
                                    Terms of Service
                                  </Link>{' '}
                                  and{' '}
                                  <Link
                                    component={RouterLink}
                                    to="/Privacy"
                                    underline="hover"
                                    style={{
                                      color: '#04a3e3',
                                    }}
                                    target="_blank"
                                  >
                                    Privacy Policy
                                  </Link>
                                </Typography>
                              }
                            />
                          </Grid>
                        </Grid>
                        <Grid
                          size={12}
                          style={{
                            marginTop: 25,
                            textAlign: 'center',
                          }}
                        >
                          <Button
                            variant="contained"
                            type="submit"
                            disabled={!agree}
                            color="primary"
                            style={{
                              fontWeight: 600,
                            }}
                          >
                            <Typography>Sign Up</Typography>
                          </Button>
                        </Grid>
                        <Grid
                          size={12}
                          style={{
                            marginTop: 10,
                            textAlign: 'center',
                          }}
                        >
                          <Typography>
                            Already a Housefolios member?
                            <Link
                              href="/signin"
                              underline="hover"
                              style={{
                                color: '#04a3e3',
                              }}
                            >
                              {' '}
                              Log in
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </ValidatorForm>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default SignupForm
